module.exports = __webpack_public_path__ + "img/ai-icon.f3c2b0ad.svg";